import React, { useEffect, useState } from "react";
import { apiAddShareholder, apiGetShareholders } from "../../api/shareholderApi";
import addWork from "../../assets/svg/registerShow/icon-add-work.svg";
import iconAddSharehlder from "../../assets/svg/icon-add-share-holder.svg";
import IconEdit from "../../assets/svg/icon-edit-compratment.svg";
import IconDelete from "../../assets/svg/icon-delete-show-account.svg";
import IconMenu from "../../assets/svg/icon-menu-account.svg";
import logoShareholders from "../../assets/svg/logo-shareholders.svg";
import IconBookMark from "../../assets/svg/icon-bookMark.svg";
import WarningBlueAlert from "../../assets/svg/warning-blue-alert-.svg";
import "../../assets/styles/shareholder/shareholder.scss";
import { apiSetAlert } from "../../api/appApi";
import iconLoading from "../../assets/svg/icon-loading.svg";
import logoShareholder from "../../assets/svg/logo-shareholder.svg";
import { appSetToggle } from "../../store/actions/appAction";
import { apiPersonsList } from "../../api/personApi";
import BasicButton from "components/BasicInputs/BasicButton";
import { Add, Close } from "@mui/icons-material";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import PercentIcon from "assets/icons/PercentIcon";
import { useAppDispatch, useAppSelector } from "store/store";

export default function Shareholders() {
  const dispatch = useAppDispatch();
  const store = useAppSelector((x: any) => x);
  const toggle = store.appReducer.toggle;
  const shareholders: ShareHolder[] = store.shareholderReducer.shareholders;
  const token = store.businessReducer.business.token;

  const [tempShareholders, setTempShareholders] = useState(shareholders);
  const [addShareholder, setAddShareholder] = useState(false);
  const [editShareholder, setEditShareholder] = useState(false);
  const [tempShareholder, setTempShareholder] = useState<ShareHolder>();
  const [tempPercent, setTempPercent] = useState<number>();
  const [showItemActions, setShowItemActions] = useState<number>();

  useEffect(() => {
    dispatch(apiGetShareholders(token));
    dispatch(apiPersonsList(token, "personnel"));
  }, [token]);
  useEffect(() => {
    setTempShareholders(shareholders);
  }, [shareholders]);

  const toggleShowUserActions = (id?: number) => {
    dispatch(appSetToggle(showItemActions !== id));
    setShowItemActions(showItemActions === id ? undefined : id);
  };

  const addTempShareholder = () => {
    if (!tempShareholder) {
      dispatch(apiSetAlert("لطفا سهامدار را انتخاب نمایید", "error"));
      return;
    }

    if (!tempPercent) {
      dispatch(apiSetAlert("لطفا درصد سهام را مشخص نمایید", "warning"));
      return;
    }

    let shareholder = tempShareholders.find((i) => i.PersonId === tempShareholder.PersonId);
    if (!shareholder || editShareholder) {
      shareholder = {
        Person: tempShareholder.Person,
        PersonId: tempShareholder.PersonId,
        percent: tempPercent,
      };
      setTempShareholders([
        ...tempShareholders.filter((s) => s.PersonId !== shareholder?.PersonId),
        shareholder,
      ]);
      resetTempShareholder();
    } else {
      dispatch(apiSetAlert("این سهامدار قبلا در لیست ثبت شده است", "warning"));
    }
  };

  const resetTempShareholder = () => {
    setTempShareholder(undefined);
    setTempPercent(0);
    setAddShareholder(false);
    setEditShareholder(false);
    setShowItemActions(undefined);
  };

  const editTempShareholder = (shareholder: ShareHolder) => {
    setAddShareholder(true);
    setEditShareholder(true);
    setShowItemActions(undefined);
    setTempShareholder(shareholder);
    setTempPercent(shareholder.percent);
  };

  const deleteTempShareholder = (id: any) => {
    const s = tempShareholders.filter((s) => s.PersonId !== id);
    setTempShareholders(s);
    setShowItemActions(undefined);
    setEditShareholder(false);
  };

  const saveShareholders = () => {
    dispatch(
      apiAddShareholder(
        tempShareholders.map(({ PersonId, percent }) => ({ PersonId, percent })),
        token
      )
    );
  };

  return (
    <div className="wrap-shareholder p-2 md:p-4">
      <div className="header-shareholder">
        <div className="header-right">
          <div>سهامداران</div>
          <div>نمایش سهامداران کسب و کار</div>
        </div>
        <div className="header-left" />
      </div>
      <div className="body-cards flex flex-col gap-6 md:grid md:grid-cols-12">
        <div className="col-span-7">
          <div className="row">
            {tempShareholders.map((shareholder, i) => {
              return (
                <ShareholderCard
                  key={i}
                  i={i}
                  shareholder={shareholder}
                  active={toggle && showItemActions === shareholder.PersonId}
                  toggleShowUserActions={toggleShowUserActions}
                  editShareholder={editTempShareholder}
                  deleteShareholder={deleteTempShareholder}
                />
              );
            })}
          </div>
        </div>
        <div className="col-span-5  md:min-w-[320px]">
          <div className="row">
            <AddShareholderCard
              shareholders={tempShareholders}
              shareholder={tempShareholder}
              setShareholder={setTempShareholder}
              percent={tempPercent}
              setPercent={setTempPercent}
              addTempShareholder={addTempShareholder}
              resetTempShareholder={resetTempShareholder}
              saveShareholders={saveShareholders}
              addShareholder={addShareholder}
              setAddShareholder={setAddShareholder}
              editShareholder={editShareholder}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const AddShareholderCard = ({
  shareholders,
  shareholder,
  setShareholder,
  percent,
  setPercent,
  addTempShareholder,
  resetTempShareholder,
  saveShareholders,
  addShareholder,
  setAddShareholder,
  editShareholder,
}: {
  shareholders: ShareHolder[];
  shareholder?: ShareHolder;
  setShareholder: React.Dispatch<React.SetStateAction<ShareHolder | undefined>>;
  percent?: number;
  setPercent: React.Dispatch<React.SetStateAction<number | undefined>>;
  addTempShareholder: () => void;
  resetTempShareholder: () => void;
  saveShareholders: () => void;
  addShareholder: boolean;
  setAddShareholder: React.Dispatch<React.SetStateAction<boolean>>;
  editShareholder: boolean;
}) => {
  const sendingRequest = useAppSelector((state: any) => state).appReducer.sendingRequest;
  const dispatch = useAppDispatch();
  const store = useAppSelector((state: any) => state);
  const personnel = store.personReducer.personnel;
  const token = store.businessReducer.business.token;
  const [totalShares, setTotalShares] = useState(0);

  useEffect(() => {
    let totalShares = 0;

    shareholders.map((item: any) => {
      if (!(editShareholder && shareholder && item.PersonId === shareholder.PersonId)) {
        totalShares += parseFloat(item.percent);
      }
    });

    setTotalShares(totalShares);
  }, [shareholders, editShareholder, addShareholder]);

  const onChangePercent = (value: number) => {
    value = value > 100 - totalShares ? 100 - totalShares : value;
    setPercent(value > 100 - totalShares ? 100 - totalShares : value);
  };

  return (
    <div className="wrap-add-shareholders">
      <div className="add-shareholder">
        <div className="wrap-add-shareholder">
          {addShareholder ? (
            <>
              <div className="flex items-center justify-between p-4">
                <div className="text-blue-1">اطلاعات سهامدار</div>
                <div className="flex items-center gap-4">
                  <BasicButton
                    variant="contained"
                    className="min-w-[40px] h-10 w-10"
                    onClick={() => addTempShareholder()}
                  >
                    <Add />
                  </BasicButton>
                  <BasicButton
                    variant="outlined"
                    color="error"
                    className="min-w-[40px] h-10 w-10"
                    onClick={() => resetTempShareholder()}
                  >
                    <Close />
                  </BasicButton>
                </div>
              </div>
              <div className="flex flex-wrap md:flex-nowrap items-center gap-4 p-4 justify-between">
                <div className="w-60">
                  <BasicSelect
                    label="سهامدار"
                    options={personnel}
                    defaultValue={shareholder?.PersonId}
                    disabled={editShareholder}
                    onChange={(val, option) => setShareholder({ Person: option, PersonId: val })}
                    withRefresh
                    refreshList={() => dispatch(apiPersonsList(token, "personnel"))}
                    withSearch
                    menuStyle={{ minWidth: 280 }}
                  />
                </div>
                <div className="w-28">
                  <BasicTextInput
                    label="درصد سهام"
                    type="number-native"
                    prefix={<PercentIcon />}
                    val={percent}
                    onChange={(val) => onChangePercent(+val)}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="item-add-shareholder" onClick={() => setAddShareholder(!addShareholder)}>
              <div className="wrap-icon-add-shareholder">
                <img src={iconAddSharehlder} alt="iconAddShareholder" />
              </div>
              <div className="add-shareholder-new">
                <img className="add-icon-shareholder" src={addWork} alt="addWork" />
                افزودن سهامدار جدید
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="total-shares-add-shareholders">
        <div>
          <b>مجموع سهام</b>
        </div>
        {}
        <div
          className={
            totalShares < 100
              ? "number-shareholders-new"
              : totalShares > 100
              ? "number-shareholders-new"
              : "number-shareholders-new-success"
          }
        >
          {totalShares}٪
        </div>
      </div>
      <div className="number-shareholders-add-shareholders">
        <div className="">تعداد سهامداران</div>
        <div>{shareholders.length}</div>
      </div>
      {totalShares !== 100 ? (
        <div className="alert-shareholder-percent">
          <div className="border-right-alert-shareholder" />
          <img src={WarningBlueAlert} alt="WarningBlueAlert" />
          <div>مجموع سهام کسب و کار باید ۱۰۰٪ باشد</div>
        </div>
      ) : null}
      <div
        className={
          totalShares !== 100 ? "wrap-btn-save-add-shareholders" : "wrap-btn-save-add-shareholders-active"
        }
      >
        <button
          disabled={totalShares !== 100 || sendingRequest}
          style={{ display: "flex", justifyContent: "center" }}
          type="button"
          onClick={() => saveShareholders()}
        >
          {sendingRequest ? (
            <img src={iconLoading} alt="loading" />
          ) : (
            <>
              <img src={IconBookMark} alt="IconBookMark" />
              ذخیره
            </>
          )}
        </button>
      </div>
    </div>
  );
};

const ShareholderCard = ({
  shareholder,
  active,
  toggleShowUserActions,
  editShareholder,
  deleteShareholder,
  i,
}: {
  shareholder: ShareHolder;
  active: boolean;
  toggleShowUserActions: (id?: number) => void;
  editShareholder: any;
  deleteShareholder: any;
  i: number;
}) => {
  const secretView = useAppSelector((state: any) => state.appReducer.secretView);

  return (
    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 style-body-card">
      <div className="card-box">
        <div className={active ? "active-toggle-menu-account" : "not-active-toggle-menu-account"}>
          <div onClick={() => editShareholder(shareholder)}>
            <img src={IconEdit} alt="IconEdit" />
            ویرایش
          </div>
          <div onClick={() => deleteShareholder(shareholder.PersonId)}>
            <img src={IconDelete} alt="IconEdit" />
            حذف سهامدار
          </div>
        </div>
        <img className="logo-original" src={logoShareholders} alt="original-logo" />
        <div className="header-card">
          <div className="right-header-card">
            <div />
            <div />
            <div className="logo-card">{i + 1}</div>
          </div>
          <div className="left-header-card">
            <img src={IconMenu} alt="IconMenu" onClick={() => toggleShowUserActions(shareholder.PersonId)} />
          </div>
        </div>
        <div className="title-card-box">
          <div className="new-div-title-card-box">
            <div className="icon-logo-title-card-box">
              <img src={logoShareholder} alt="logoShareholder" />
            </div>
            <div>
              <div>
                {secretView
                  ? "********"
                  : `${shareholder.Person?.accountingCode} - ${shareholder?.Person?.nickName}`}
              </div>
              {/*<div className="text-small-card-box">{shareholder?.Roles[0]?.fa_title ?? ''}</div>*/}
            </div>
          </div>
          <div className="count-title-card-box">{secretView ? "********" : shareholder.percent}%</div>
        </div>
        <p className="text-number-card">
          {/* <img src={chartIconShareholder} alt="chartIconShareholder" /> */}
        </p>
        <div className="line-card" />
        <div className="footer-card">
          <span>تاریخ ثبت : {secretView ? "********" : shareholder?.createdAt}</span>
        </div>
      </div>
    </div>
  );
};
